import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import { EnvironmentService } from '../../../app/services/environment.service';
import { TooltipModel } from '../../models/tooltip';
import { ResponseBase } from '../../models/commonModels';
import * as PricelistCurrentModels from '../../models/pricelist-current/pricelist-current';
import { PricelistCurrentSearchModel, PricelistOfferModel } from '../../models/pricelist-current/pricelist-currentSearch';

@Injectable({
  providedIn: 'root'
})
export class PricelistCurrentService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }

  public get(Search: PricelistCurrentSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };
    return this.httpClient.post<PricelistCurrentModels.PricelistCurrentListModel>(
      `${this.environmentService.getApiURL()}/pricelist/current/list`, Search, options);
  }

  public ClearListPromoCode(Search: PricelistCurrentSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };
    return this.httpClient.post<PricelistCurrentModels.PricelistCurrentListModel>(
      `${this.environmentService.getApiURL()}/pricelist/current/list-clear-promo-code`, Search, options);
  }

  public sendOfferPdf(InputData: PricelistOfferModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };
    return this.httpClient.post(
      `${this.environmentService.getApiURL()}/pricelist/current/offer/mail`, InputData, options);
  }

  public getOfferXLS(InputData: PricelistOfferModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/pricelist/current/offer/xls`, InputData, options);
  }

  public getOfferPdf(InputData: PricelistOfferModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };

    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/pricelist/current/offer/pdf`, InputData, options);
  }

  public getReport(Search: PricelistCurrentSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/pricelist/current/report/`, Search, options);
  }

  public getCustomerReport(Search: PricelistCurrentSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders, responseType: 'blob' as 'json'};
    return this.httpClient.post<Blob>(`${this.environmentService.getApiURL()}/pricelist/current/customerreport/`, Search, options);
  }

  public ImportPromoCode(Data: any) {

    const httpHeaders = new HttpHeaders()
      .set('Cache-Control', 'no-cache');

    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/pricelist/detail/import-promo-code`, Data, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

/*  public importData(formData: FormData) {
    // !!! not working with headers
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'multipart/form-data')
    .set('Accept', 'application/json');
    const options = {headers: httpHeaders};

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<PricelistCurrentModels.PricelistCurrentUpdateResponse>(
      `${this.environmentService.getApiURL()}/pricelist-current/list/import`, formData);
  }
*/

}
